// src/screens/tabs/styles.ts
import { StyleSheet } from "react-native";
import { FlickOColors } from "./color";
import { getResponsiveSize } from "./globalStyles";

export const borderStyles = {
  borderWidth: 1,
  borderColor: FlickOColors.gray.light,
  elevation: 3,
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.25,
  shadowRadius: 3.84,
};

export const menuScreenStyles = StyleSheet.create({
  ratingBadge: {
    borderRadius: getResponsiveSize(4), // Rounded corners
    paddingHorizontal: getResponsiveSize(6),
    paddingVertical: getResponsiveSize(4),
    justifyContent: "center",
    alignItems: "center",
    width: getResponsiveSize(50),
  },
  ratingText: {
    color: FlickOColors.white, // White text
    fontSize: getResponsiveSize(14),
    fontWeight: "600",
  },
  borderTop: {
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.light,
    borderRadius: 3.84,
  },
  upiContainer: {
    marginTop: getResponsiveSize(8),
    alignItems: "flex-start",
  },
  itemDetails: {
    flex: 1,
    marginRight: getResponsiveSize(16),
  },
  itemDescription: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    marginTop: getResponsiveSize(4),
  },
  billContainer: {
    backgroundColor: FlickOColors.white,
    padding: getResponsiveSize(16),
  },
  billTitle: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
    marginBottom: getResponsiveSize(16),
  },
  billRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: getResponsiveSize(12),
  },
  billLabel: {
    color: FlickOColors.text.secondary,
    fontSize: getResponsiveSize(14),
  },
  billValue: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  billTotal: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: getResponsiveSize(16),
    paddingTop: getResponsiveSize(16),
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.lighter,
  },
  totalText: {
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
  },
  totalAmount: {
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
    color: FlickOColors.success,
  },
  payButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
    textAlign: "center",
  },
  savedAmount: {
    color: FlickOColors.success,
    fontSize: getResponsiveSize(14),
    marginTop: getResponsiveSize(4),
  },
  actionsContainer: {
    flexDirection: "row",
    padding: getResponsiveSize(16),
    gap: getResponsiveSize(12),
  },
  sectionTitle: {
    fontSize: getResponsiveSize(20),
    fontWeight: "600",
    padding: getResponsiveSize(16),
  },
  eligibleItemsSection: {
    backgroundColor: FlickOColors.green,
  },
  priceQuantityContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  quantityControl: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(12),
  },
  priceContainer: {
    alignItems: "flex-end",
  },
  discountedPrice: {
    color: FlickOColors.success,
    fontWeight: "600",
  },
  cartItemContainer: {
    padding: getResponsiveSize(16),
    backgroundColor: FlickOColors.white,
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.lighter,
  },
  payButton: {
    backgroundColor: FlickOColors.success,
    padding: getResponsiveSize(16),
    margin: getResponsiveSize(16),
    borderRadius: getResponsiveSize(8),
    alignItems: "center",
  },
  border: {
    ...borderStyles,
  },
  menuAddBtn: {
    ...borderStyles,
    backgroundColor: FlickOColors.white,
    padding: getResponsiveSize(8),
    borderRadius: 8,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    position: "absolute",
    bottom: -getResponsiveSize(20), // Half outside image
    alignSelf: "center",
    width: "75%",
  },
  addButtonText: {
    color: FlickOColors.success,
    fontWeight: "600",
    fontSize: getResponsiveSize(20),
    textAlign: "center",
  },
  filtersScrollView: {
    flexGrow: 0,
    backgroundColor: FlickOColors.white,
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },
  filtersContentContainer: {
    paddingHorizontal: getResponsiveSize(16),
    paddingVertical: getResponsiveSize(12),
  },
  editButton: {
    position: "absolute",
    top: getResponsiveSize(12),
    right: getResponsiveSize(12),
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: getResponsiveSize(8),
    padding: getResponsiveSize(12),
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
  },
  editText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  imageContainer: {
    position: "relative",
  },
  divider: {
    height: 1,
    backgroundColor: FlickOColors.gray.light,
    marginVertical: getResponsiveSize(12),
  },
  menuItemCard: {
    flexDirection: "row",
    backgroundColor: FlickOColors.white,
    borderRadius: 8,
    // padding: getResponsiveSize(16),
    marginBottom: getResponsiveSize(12),
  },

  contentSection: {
    flex: 1,
    marginRight: getResponsiveSize(16),
  },
  typeIconContainer: {
    marginBottom: getResponsiveSize(8),
  },
  foodTypeIcon: {
    width: getResponsiveSize(20),
    height: getResponsiveSize(20),
    borderRadius: 4,
    borderWidth: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  vegIcon: {
    borderColor: "#00A877",
  },
  nonVegIcon: {
    borderColor: "#FF0000",
  },
  eggIcon: {
    borderColor: "#FFB52E",
  },
  innerDot: {
    width: getResponsiveSize(12),
    height: getResponsiveSize(12),
    borderRadius: 6,
  },
  eggText: {
    fontSize: getResponsiveSize(12),
  },
  itemName: {
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
    marginBottom: getResponsiveSize(4),
  },
  ratingContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: getResponsiveSize(4),
  },
  star: {
    color: "#FFB52E",
    marginRight: getResponsiveSize(2),
  },
  ratingCount: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
    marginLeft: getResponsiveSize(4),
  },
  price: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.primary,
    fontWeight: "600",
    marginBottom: getResponsiveSize(4),
  },
  description: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
  },
  showMoreText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(12),
    marginTop: getResponsiveSize(4),
  },
  itemImage: {
    width: getResponsiveSize(160),
    height: getResponsiveSize(160),
    borderRadius: 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.lighter,
    backgroundColor: FlickOColors.white,
  },
  stockToggle: {
    alignSelf: "flex-start",
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
    backgroundColor: FlickOColors.success + "20",
  },
  outOfStock: {
    backgroundColor: FlickOColors.error + "20",
  },
  stockText: {
    fontSize: 12,
    color: FlickOColors.success,
  },
  outOfStockText: {
    color: FlickOColors.error,
  },
  container: {
    flex: 1,
    backgroundColor: FlickOColors.gray.lightest,
  },
  header: {
    padding: getResponsiveSize(16),
    backgroundColor: FlickOColors.white,
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },
  headerTitle: {
    fontSize: getResponsiveSize(20),
    fontWeight: "600",
  },
  profileSection: {
    backgroundColor: FlickOColors.white,
  },
  profileImage: {
    width: "100%",
    height: getResponsiveSize(200),
    resizeMode: "cover",
  },
  contentWrapper: {
    padding: getResponsiveSize(16),
    width: "100%",
  },
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  restaurantInfo: {
    flex: 1,
    marginRight: getResponsiveSize(16),
  },
  restaurantName: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
    marginBottom: getResponsiveSize(4),
  },
  cuisineContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: getResponsiveSize(8),
    marginTop: getResponsiveSize(8),
  },
  cuisineText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    margin: getResponsiveSize(16),
    padding: getResponsiveSize(12),
    backgroundColor: FlickOColors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    gap: getResponsiveSize(8),
  },
  searchInput: {
    flex: 1,
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.primary,
    padding: 0, // Removes default padding
  },
  categoryCard: {
    backgroundColor: FlickOColors.white,
    marginBottom: getResponsiveSize(16),
    padding: getResponsiveSize(16),
  },
  categoryTitle: {
    fontSize: getResponsiveSize(20),
    fontWeight: "600",
    marginBottom: getResponsiveSize(16),
  },
  subCategoryContainer: {
    marginBottom: getResponsiveSize(16),
  },
  subCategoryHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: getResponsiveSize(12),
  },
  subCategoryTitle: {
    fontSize: getResponsiveSize(16),
    fontWeight: "800",
    color: FlickOColors.gray.dark2,
  },
  toggleButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(4),
    padding: getResponsiveSize(8),
    borderRadius: 16,
    backgroundColor: FlickOColors.gray.lightest,
    width: getResponsiveSize(100),
    justifyContent: "center",
    alignSelf: "flex-start",
  },
  toggleButtonEnabled: {
    backgroundColor: FlickOColors.success + "10",
  },
  toggleText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  toggleTextEnabled: {
    color: FlickOColors.success,
  },
  emptyText: {
    color: FlickOColors.text.secondary,
    fontSize: getResponsiveSize(14),
  },
});
